import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { NumericalInput } from '../../../../../../../atomic/atomicComponentLibrary/numericalInput/NumericalInput';
import { Body3, Body4, fontSizes } from '../../../../../../../atomic/text/Text';
import style from '../SimpleTacticStyle.module.css';

export const SimpleRatchetBracket = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const defaultFn = () => {};
  const isEnabled = tradePlanForm.exitTactics.RATCHET_BRACKET ?? false;
  const targetPerBracket =
    tradePlanForm.exitTactics.RATCHET_BRACKET?.targetPerBracket ?? 1;
  const setTargetPerBracket =
    tradePlanForm.exitTactics.RATCHET_BRACKET?.setTargetPerBracket ?? defaultFn;
  const stopPerBracket =
    tradePlanForm.exitTactics.RATCHET_BRACKET?.stopPerBracket ?? 1;
  const setStopPerBracket =
    tradePlanForm.exitTactics.RATCHET_BRACKET?.setStopPerBracket ?? defaultFn;
  const qtyBasisValuePerBracket =
    tradePlanForm.exitTactics.RATCHET_BRACKET?.qtyBasisValuePerBracket ?? 25;
  const setQtyBasisValuePerBracket =
    tradePlanForm.exitTactics.RATCHET_BRACKET?.setQtyBasisValuePerBracket ??
    defaultFn;
  return (
    <div className={style.container}>
      <div className={style.labelAndCheckbox}>
        <input
          style={{ margin: '0 5px 0 0' }}
          type="checkbox"
          checked={isEnabled}
          onChange={() => {
            if (isEnabled) {
              tradePlanForm.removeExitTactic('RATCHET_BRACKET');
            } else {
              tradePlanForm.addExitTactic('RATCHET_BRACKET');
            }
          }}
        />
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Ratchet Bracket
        </Body3>
      </div>
      <div className={style.controlsThree}>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Target</Body4>
          <NumericalInput
            disabled={!isEnabled}
            icon="$"
            width="30px"
            maxHeight="23px"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={targetPerBracket}
            onChange={setTargetPerBracket}
          />
        </div>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Stop</Body4>
          <NumericalInput
            disabled={!isEnabled}
            icon="$"
            width="30px"
            maxHeight="23px"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={stopPerBracket}
            onChange={setStopPerBracket}
          />
        </div>
        <div className={style.labelAndControl}>
          <Body4 color={colors.lightGrey}>Percent</Body4>
          <NumericalInput
            disabled={!isEnabled}
            icon="%"
            width="30px"
            maxHeight="23px"
            fontSize={fontSizes.body4}
            fontColor="white"
            backgroundColor="grey"
            controlledValue={qtyBasisValuePerBracket}
            onChange={setQtyBasisValuePerBracket}
          />
        </div>
      </div>
    </div>
  );
});
